/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: string; output: string }
}

export enum CentralLockState {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED',
}

export enum ChargingMode {
  Ac = 'AC',
  Dc = 'DC',
  Off = 'OFF',
}

export enum ConnectedState {
  ConnectedInterrupted = 'CONNECTED_INTERRUPTED',
  ConnectedOffline = 'CONNECTED_OFFLINE',
  ConnectedOnline = 'CONNECTED_ONLINE',
  ConnectedStateUnknown = 'CONNECTED_STATE_UNKNOWN',
}

export enum DoorState {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type FccAdConnectivity = {
  __typename?: 'FccAdConnectivity'
  connectivityState: FccAdConnectivityState
  timestamp: Scalars['DateTime']['output']
}

export enum FccAdConnectivityState {
  Connected = 'CONNECTED',
  Interrupted = 'INTERRUPTED',
}

export enum FccDoorActuationError {
  /** The door state did not switch to the desired state in time */
  DoorStateMismatch = 'DOOR_STATE_MISMATCH',
  SlidingDoorDeactivated = 'SLIDING_DOOR_DEACTIVATED',
  /** No response was received in time */
  TtlExceeded = 'TTL_EXCEEDED',
  UnknownError = 'UNKNOWN_ERROR',
  VehicleMoving = 'VEHICLE_MOVING',
  VehicleNotParked = 'VEHICLE_NOT_PARKED',
}

export type FccDoorActuationNotPossibleStatus = {
  __typename?: 'FccDoorActuationNotPossibleStatus'
  vehicleId: Scalars['ID']['output']
}

export type FccDoorActuationPossibleStatus = {
  __typename?: 'FccDoorActuationPossibleStatus'
  vehicleId: Scalars['ID']['output']
}

export type FccDoorActuationRequestFailureStatus = {
  __typename?: 'FccDoorActuationRequestFailureStatus'
  errors: Array<FccDoorActuationError>
  vehicleId: Scalars['ID']['output']
}

export type FccDoorActuationRequestInitiatedStatus = {
  __typename?: 'FccDoorActuationRequestInitiatedStatus'
  desiredDoorState: FccTargetDoorStatus
  vehicleId: Scalars['ID']['output']
}

export type FccDoorActuationRequestSuccessStatus = {
  __typename?: 'FccDoorActuationRequestSuccessStatus'
  vehicleId: Scalars['ID']['output']
}

export type FccDoorActuationStatus =
  | FccDoorActuationNotPossibleStatus
  | FccDoorActuationPossibleStatus
  | FccDoorActuationRequestFailureStatus
  | FccDoorActuationRequestSuccessStatus

export type FccDoorRequestStatus = {
  __typename?: 'FccDoorRequestStatus'
  errors: Array<FccDoorActuationError>
  status: FccRequestStatus
  vehicleId: Scalars['ID']['output']
}

export enum FccDoorState {
  Ajar = 'AJAR',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING',
}

export type FccDoorStatus = {
  __typename?: 'FccDoorStatus'
  doorState: FccDoorState
  updatedAt: Scalars['DateTime']['output']
}

export enum FccEmergencyStopError {
  /** The emergency stop request was rejected by the vehicle */
  Failed = 'FAILED',
  /** No response was received in time */
  TtlExceeded = 'TTL_EXCEEDED',
  UnknownError = 'UNKNOWN_ERROR',
}

export type FccEmergencyStopStatus = {
  __typename?: 'FccEmergencyStopStatus'
  errors: Array<FccEmergencyStopError>
  failedReason: Maybe<Scalars['String']['output']>
  status: FccRequestStatus
  vehicleId: Scalars['ID']['output']
}

export type FccManageServiceError = {
  __typename?: 'FccManageServiceError'
  code: FccManageServiceErrorCode
}

export enum FccManageServiceErrorCode {
  Failed = 'FAILED',
  Timeout = 'TIMEOUT',
}

export type FccManageServiceProgress = {
  __typename?: 'FccManageServiceProgress'
  error: Maybe<FccManageServiceError>
  sessionId: Scalars['ID']['output']
  status: FccManageServiceStatusEnum
  vehicleId: Scalars['ID']['output']
}

export enum FccManageServiceStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Timeout = 'TIMEOUT',
}

export type FccMostCriticalVehicle = {
  __typename?: 'FccMostCriticalVehicle'
  /** Was this vehicle previously dismissed by the subscribed user? */
  dismissed: Scalars['Boolean']['output']
  /** User who is currently handling the vehicle. Null if no one is handling it */
  handledByBackofficeUserId: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
}

export type FccMostCriticalVehicleAssignment = {
  __typename?: 'FccMostCriticalVehicleAssignment'
  backofficeUserId: Scalars['ID']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  regionId: Scalars['ID']['output']
  vehicle: Maybe<FccMostCriticalVehicle>
}

export enum FccRequestStatus {
  Failure = 'FAILURE',
  Initiated = 'INITIATED',
  Success = 'SUCCESS',
}

export type FccRouteLocation = {
  __typename?: 'FccRouteLocation'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export enum FccSdsMission {
  AssessDrivingNeed = 'ASSESS_DRIVING_NEED',
  AtStop = 'AT_STOP',
  EmergencyInProgress = 'EMERGENCY_IN_PROGRESS',
  EmergencyParked = 'EMERGENCY_PARKED',
  Idle = 'IDLE',
  Invalid = 'INVALID',
  OnDuty = 'ON_DUTY',
  RequestToDrive = 'REQUEST_TO_DRIVE',
  SafetyCheck = 'SAFETY_CHECK',
}

export enum FccSdsMode {
  Disengaged = 'DISENGAGED',
  Engaged = 'ENGAGED',
  Fault = 'FAULT',
  InCalibration = 'IN_CALIBRATION',
  NotAuthorized = 'NOT_AUTHORIZED',
  Transportation = 'TRANSPORTATION',
}

export type FccSdsRideExecutionError = {
  __typename?: 'FccSdsRideExecutionError'
  rejectionReason: Maybe<FccSdsRideRejectionReason>
  timestamp: Scalars['DateTime']['output']
  type: FccSdsRideExecutionErrorType
}

export enum FccSdsRideExecutionErrorType {
  DrivingTimeout = 'DRIVING_TIMEOUT',
  RideAcceptedTimeout = 'RIDE_ACCEPTED_TIMEOUT',
  RideRejectedOnDuty = 'RIDE_REJECTED_ON_DUTY',
  RideRejectedStationary = 'RIDE_REJECTED_STATIONARY',
  UnknownError = 'UNKNOWN_ERROR',
}

export enum FccSdsRideRejectionReason {
  RouteRejected = 'ROUTE_REJECTED',
  SdsInWrongStatus = 'SDS_IN_WRONG_STATUS',
  SdsNotEngaged = 'SDS_NOT_ENGAGED',
}

export type FccSeatStatus = {
  __typename?: 'FccSeatStatus'
  cockpitLeft: FccSeatStatusType
  cockpitRight: FccSeatStatusType
  secondRowLeft: FccSeatStatusType
  secondRowMiddle: FccSeatStatusType
  secondRowRight: FccSeatStatusType
  thirdRowLeft: FccSeatStatusType
  thirdRowMiddle: FccSeatStatusType
  thirdRowRight: FccSeatStatusType
}

export enum FccSeatStatusType {
  Buckled = 'BUCKLED',
  NotInstalled = 'NOT_INSTALLED',
  NotOccupied = 'NOT_OCCUPIED',
  Unbuckled = 'UNBUCKLED',
}

export type FccServiceCancellationError = {
  __typename?: 'FccServiceCancellationError'
  code: FccServiceCancellationErrorCode
}

export enum FccServiceCancellationErrorCode {
  Failed = 'FAILED',
  Timeout = 'TIMEOUT',
}

export enum FccServiceCancellationPassengerAuthenticationStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  ManualNoShowPending = 'MANUAL_NO_SHOW_PENDING',
  ManualNoShowRequested = 'MANUAL_NO_SHOW_REQUESTED',
  ManualPassengerCheckInPending = 'MANUAL_PASSENGER_CHECK_IN_PENDING',
  NoShowTriggered = 'NO_SHOW_TRIGGERED',
  Upcoming = 'UPCOMING',
}

export type FccServiceCancellationState = {
  __typename?: 'FccServiceCancellationState'
  cancellationError: Maybe<FccServiceCancellationError>
  cancellationType: Maybe<FccServiceCancellationTypeEnum>
  state: Maybe<FccServiceCancellationStateEnum>
  trips: Maybe<Array<FccServiceCancellationTrip>>
  vehicleId: Scalars['ID']['output']
}

export enum FccServiceCancellationStateEnum {
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Initiated = 'INITIATED',
  Processed = 'PROCESSED',
}

export type FccServiceCancellationTrip = {
  __typename?: 'FccServiceCancellationTrip'
  isBoarded: Scalars['Boolean']['output']
  passengerAuthenticationStatus: FccServiceCancellationPassengerAuthenticationStatusEnum
  tripId: Scalars['ID']['output']
}

export enum FccServiceCancellationTypeEnum {
  AllTrips = 'ALL_TRIPS',
  SomeTrips = 'SOME_TRIPS',
}

export enum FccTargetDoorStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type FccVehicleHandlingUpdate = {
  __typename?: 'FccVehicleHandlingUpdate'
  callActive: Scalars['Boolean']['output']
  /** Provided subscription input parameter for filtering */
  vehicleId: Scalars['ID']['output']
  videoStreamActive: Scalars['Boolean']['output']
}

export type FccVehicleLocation = {
  __typename?: 'FccVehicleLocation'
  /** meters per second */
  speed: Scalars['Float']['output']
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehicleId: Scalars['String']['output']
}

export type FccVehicleRoute = {
  __typename?: 'FccVehicleRoute'
  /**
   * encodedPath is the lossy compressed representation of the route path.
   * It is encoded using '@here/flexpolyline' and should be decoded using the same library.
   */
  encodedPath: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
  vehicleId: Scalars['ID']['output']
}

export type FccVehicleTelemetry = {
  __typename?: 'FccVehicleTelemetry'
  cabinConnectivity: Maybe<FccAdConnectivity>
  centralLockLocked: Maybe<Scalars['Boolean']['output']>
  consumedEnergy: Maybe<Scalars['Float']['output']>
  /** @deprecated Use rightSlidingDoorOpen instead */
  doorsOpen: Maybe<Scalars['Boolean']['output']>
  ignitionOn: Maybe<Scalars['Boolean']['output']>
  interiorTemperatureCelsius: Maybe<Scalars['Float']['output']>
  mileageKilometer: Maybe<Scalars['Int']['output']>
  missionConnectivity: Maybe<FccAdConnectivity>
  remainingCruisingRangeKilometer: Maybe<Scalars['Float']['output']>
  rightSlidingDoor: Maybe<FccDoorStatus>
  rightSlidingDoorOpen: Maybe<Scalars['Boolean']['output']>
  sdsConnectivity: Maybe<FccAdConnectivity>
  sdsMission: Maybe<FccSdsMission>
  sdsMissionUpdatedAt: Maybe<Scalars['DateTime']['output']>
  sdsMode: Maybe<FccSdsMode>
  sdsModeUpdatedAt: Maybe<Scalars['DateTime']['output']>
  sdsRideExecutionError: Maybe<FccSdsRideExecutionError>
  seatStatus: Maybe<FccSeatStatus>
  signalConnectivity: Maybe<FccAdConnectivity>
  stateOfChargePercentage: Maybe<Scalars['Float']['output']>
  vehicleId: Scalars['String']['output']
}

export enum IgnitionState {
  Off = 'OFF',
  On = 'ON',
}

export enum KeyFobState {
  Empty = 'EMPTY',
  Inserted = 'INSERTED',
}

export type Location = {
  __typename?: 'Location'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type LocationWithTimestamp = {
  __typename?: 'LocationWithTimestamp'
  location: Maybe<Location>
  timestamp: Maybe<Scalars['DateTime']['output']>
}

export enum PassengerAuthenticationState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  ManualNoShowRequested = 'MANUAL_NO_SHOW_REQUESTED',
  NoShowTriggered = 'NO_SHOW_TRIGGERED',
  Upcoming = 'UPCOMING',
}

export type PassengerAuthenticationStateUpdate = {
  __typename?: 'PassengerAuthenticationStateUpdate'
  fleetVehicle: Scalars['ID']['output']
  state: PassengerAuthenticationState
  tripId: Scalars['ID']['output']
}

export enum PowerplugState {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
}

/** It is required that a GraphQL schema has a query, you can ignore this */
export type Query = {
  __typename?: 'Query'
  CANARY_health: Maybe<Scalars['String']['output']>
  fccAdAlerts: Scalars['String']['output']
  fccServiceCancellation: Scalars['String']['output']
  fccVehicleCalls: Scalars['String']['output']
  fccVehicleInteraction: Scalars['String']['output']
  fccVehicleMission: Scalars['String']['output']
  fccVehicleStatus: Scalars['String']['output']
  serverTime: Scalars['Float']['output']
  serverTime2: Scalars['Float']['output']
  vehicleMissionSync: Scalars['String']['output']
}

export enum SdsMode {
  Disengaged = 'DISENGAGED',
  Engaged = 'ENGAGED',
  Fault = 'FAULT',
  InCalibration = 'IN_CALIBRATION',
  NotAuthorized = 'NOT_AUTHORIZED',
  Transportation = 'TRANSPORTATION',
}

export enum SdgIncomingCallStatus {
  Cancelled = 'CANCELLED',
  Ringing = 'RINGING',
}

export type SdgIncomingCallUpdate = {
  __typename?: 'SdgIncomingCallUpdate'
  meetingId: Scalars['ID']['output']
  status: SdgIncomingCallStatus
  vehicleId: Scalars['ID']['output']
}

export type Subscription = {
  __typename?: 'Subscription'
  /** Used to check if the Subscription Gateway works end-to-end. Returns your connection context as stringified JSON. */
  CANARY_context: Scalars['String']['output']
  /** Used to check if the Subscription Gateway works end-to-end. Returns ISO8601 DateTime. */
  CANARY_timestamp: Scalars['String']['output']
  currentTime: Scalars['Float']['output']
  fccDoorRequestStatus: FccDoorRequestStatus
  fccEmergencyStopStatus: FccEmergencyStopStatus
  fccManageServiceProgress: FccManageServiceProgress
  /** Subscribe to the most critical vehicle which needs to be handled */
  fccMostCriticalVehicle: Maybe<FccMostCriticalVehicleAssignment>
  /** @deprecated Use fccManageServiceProgress instead */
  fccServiceCancellationState: FccServiceCancellationState
  /** Subscribe to changes in handling a specific vehicle */
  fccVehicleHandlingUpdates: Maybe<FccVehicleHandlingUpdate>
  fccVehicleLocation: FccVehicleLocation
  fccVehicleRoute: FccVehicleRoute
  fccVehicleTelemetry: FccVehicleTelemetry
  passengerAuthenticationState: PassengerAuthenticationStateUpdate
  /**
   * Subscribe to incoming call notifications for a vehicle's safety driver.
   * Publishes RINGING when an operator initiates a call, and CANCELLED when the call is cancelled or times out.
   */
  sdgIncomingCall: Maybe<SdgIncomingCallUpdate>
  vehicleHubInformation: VehicleHubInformation
  vehicleInteraction: VehicleInteractionResponse
  vehicleTelematics: TelematicBoxState
}

export type SubscriptionFccDoorRequestStatusArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionFccEmergencyStopStatusArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionFccManageServiceProgressArgs = {
  vehicleId: Scalars['String']['input']
}

export type SubscriptionFccMostCriticalVehicleArgs = {
  backofficeUserId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

export type SubscriptionFccServiceCancellationStateArgs = {
  vehicleId: Scalars['String']['input']
}

export type SubscriptionFccVehicleHandlingUpdatesArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionFccVehicleLocationArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionFccVehicleRouteArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionFccVehicleTelemetryArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionPassengerAuthenticationStateArgs = {
  fleetVehicle: Scalars['ID']['input']
  tripId: Scalars['ID']['input']
}

export type SubscriptionSdgIncomingCallArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionVehicleHubInformationArgs = {
  vehicleId: Scalars['ID']['input']
}

export type SubscriptionVehicleInteractionArgs = {
  id: Scalars['ID']['input']
}

export type SubscriptionVehicleTelematicsArgs = {
  vehicleId: Scalars['ID']['input']
}

export type TelematicBoxState = {
  __typename?: 'TelematicBoxState'
  batteryEnergy: Maybe<Scalars['Float']['output']>
  batteryVoltage: Maybe<Scalars['Float']['output']>
  centralLock: Maybe<CentralLockState>
  chargingMode: Maybe<ChargingMode>
  climateControlActive: Maybe<Scalars['Boolean']['output']>
  connectedState: Maybe<ConnectedState>
  consumedEnergy: Maybe<Scalars['Float']['output']>
  cruisingRange: Maybe<Scalars['Float']['output']>
  doors: Maybe<DoorState>
  highVoltageBatteryHealth: Maybe<Scalars['Float']['output']>
  highVoltageBatteryLevel: Maybe<Scalars['Float']['output']>
  ignition: Maybe<IgnitionState>
  interiorTemperature: Maybe<Scalars['Float']['output']>
  keyFob: Maybe<KeyFobState>
  /** @deprecated Please use locationWithTimestamp instead */
  location: Maybe<Location>
  /** @deprecated Please use locationWithTimestamp instead */
  locationTimestamp: Maybe<Scalars['DateTime']['output']>
  locationWithTimestamp: Maybe<LocationWithTimestamp>
  mileage: Maybe<Scalars['Float']['output']>
  powerPlug: Maybe<PowerplugState>
  remainingCruisingRange: Maybe<Scalars['Float']['output']>
  sdsMode: Maybe<SdsMode>
  speed: Maybe<Scalars['Float']['output']>
  targetTemperature: Maybe<Scalars['Float']['output']>
  timestamp: Maybe<Scalars['DateTime']['output']>
  vehicleId: Scalars['ID']['output']
  windows: Maybe<WindowState>
}

export type VehicleHubInformation = {
  __typename?: 'VehicleHubInformation'
  /** The hub the vehicle is currently located in (might also just be a shift break to charge the vehicle). Null if the vehicle is in the field. */
  locatedInHub: Maybe<Scalars['ID']['output']>
  vehicleId: Scalars['ID']['output']
}

export enum VehicleInteractionError {
  AlreadyOpenedAnotherVehicle = 'ALREADY_OPENED_ANOTHER_VEHICLE',
  BoxProviderException = 'BOX_PROVIDER_EXCEPTION',
  CentralLockingTimeout = 'CENTRAL_LOCKING_TIMEOUT',
  EmployeeIdMissing = 'EMPLOYEE_ID_MISSING',
  EmployeeSuspended = 'EMPLOYEE_SUSPENDED',
  MissingPermission = 'MISSING_PERMISSION',
  NoBoxId = 'NO_BOX_ID',
  PreconditionDoorOpen = 'PRECONDITION_DOOR_OPEN',
  PreconditionFuelCardMissing = 'PRECONDITION_FUEL_CARD_MISSING',
  PreconditionIgnitionOn = 'PRECONDITION_IGNITION_ON',
  PreconditionKeyFob = 'PRECONDITION_KEY_FOB',
  PreconditionLightsOn = 'PRECONDITION_LIGHTS_ON',
  PreconditionWindowOpen = 'PRECONDITION_WINDOW_OPEN',
  ShiftIdMissing = 'SHIFT_ID_MISSING',
  StateIncompatible = 'STATE_INCOMPATIBLE',
  Unknown = 'UNKNOWN',
  VehicleAlreadyClosed = 'VEHICLE_ALREADY_CLOSED',
  VehicleAlreadyOpen = 'VEHICLE_ALREADY_OPEN',
  VehicleClosedWithHardwareKey = 'VEHICLE_CLOSED_WITH_HARDWARE_KEY',
  VehicleInteractionInFlightConflict = 'VEHICLE_INTERACTION_IN_FLIGHT_CONFLICT',
  VehicleNotFound = 'VEHICLE_NOT_FOUND',
  VehicleOpenedWithHardwareKey = 'VEHICLE_OPENED_WITH_HARDWARE_KEY',
  VehicleReservedToOpen = 'VEHICLE_RESERVED_TO_OPEN',
  VehicleTooFarAway = 'VEHICLE_TOO_FAR_AWAY',
  WrongEmployee = 'WRONG_EMPLOYEE',
}

export type VehicleInteractionResponse = {
  __typename?: 'VehicleInteractionResponse'
  errors: Array<VehicleInteractionError>
  id: Scalars['ID']['output']
  success: Scalars['Boolean']['output']
}

export enum WindowState {
  AllClosed = 'ALL_CLOSED',
  Open = 'OPEN',
}
